<ig-card class="event-card"
    [class.long-card-wrap]="customSettings?.calendarStyle?.event==='long'||customSettings?.calendarStyle?.event==='modern-block'"
    [class.square-card-wrap]="customSettings?.calendarStyle?.event==='square'||customSettings?.calendarStyle?.event==='default'"
    [picture]="event.cover?.source" [isOperating]="isOperating" (click)="jumpToFacebook()">
    <div status (click)="$event.stopPropagation()">
        <div class="status-first">
            <div class="approved" *ngIf="event.isApproved">approved</div>
            <div class="unapproved" *ngIf="!event.isApproved">pending approval</div>
            <div class="enlarge-image" *ngIf="shouldShowEnlargeImage" (click)="enlargeImage($event)"
                matTooltip="The clarity of this image seems insufficient. Click here to try upscaling it">
                <mat-icon>autorenew</mat-icon>upscale image
            </div>
            <div class="pinned" *ngIf="event.pinnedTime">pinned</div>
            <div [ngClass]="{ pinned: !event.pinnedTime, choice: !!event.pinnedTime }"
                *ngIf="customSettings&&!customSettings.isHideEditorChoice&&event.isChoice">
                {{ editorChoiceText }}
            </div>
            <div class="pinned" [class.custom]="
          (event.pinnedTime && !event.isChoice) ||
          (!event.pinnedTime && event.isChoice)
        " [class.custombottom]="event.pinnedTime && event.isChoice" *ngIf="event.isCustom">
                in custom button
            </div>
        </div>

        <div class="status-second">
            <div *ngIf="isItineraryOn&&isInTour()">in itineraries</div>
            <div *ngIf="event.isToBeExport">PDF</div>
            <div *ngIf="isInCustomBtn()">in custom btn</div>
            <div *ngIf="event.isLocked" style="background:#4c90f0">Locked</div>
            <!--<div style="background-color: orange" *ngIf="!event.isApproved&&event.socialName==='Mozenda'">Mozenda</div>-->
        </div>
        <div class="status-cancel">
            <div *ngIf="event.isCancelled">Cancelled</div>
            <div *ngIf="!event.isOnlineEvent&&(!event.address?.lat||!event.address?.lng)"
                matTooltip="The address for this event may not be accurate, or it is not a recognized Google Maps address. Please edit in the Edit Event page; otherwise, the event will not be displayed in Map View">
                verify address
            </div>
        </div>
    </div>

    <div #card *ngIf="!isOperating" actions>
        <div (click)="
        event.isApproved ? unApprove() : approve(); $event.stopPropagation()
      ">
            <ig-card-action *ngIf="!event.isApproved" icon="done" matTooltip="Approve" matTooltipClass="card-tooltip"
                matTooltipPosition="right">
            </ig-card-action>
            <ig-card-action *ngIf="event.isApproved" icon="clear" matTooltip="Unapprove" matTooltipClass="card-tooltip"
                matTooltipPosition="right">
            </ig-card-action>
        </div>

        <!-- <div *ngIf="event.socialName === 'serp|google' " (click)="enlargeImage($event)">
            <ig-card-action icon="zoom_in" matTooltip="Enlarge Image" matTooltipClass="card-tooltip"
                matTooltipPosition="right">
            </ig-card-action>
        </div> -->

        <div (click)="event.pinnedTime ? unPin() : pin(); $event.stopPropagation()">
            <ig-card-action *ngIf="!event.pinnedTime" icon="pin_drop" matTooltip="Pin to top"
                matTooltipClass="card-tooltip" matTooltipPosition="right">
            </ig-card-action>
            <ig-card-action *ngIf="event.pinnedTime" icon="location_off" matTooltip="Unpin"
                matTooltipClass="card-tooltip" matTooltipPosition="right">
            </ig-card-action>
        </div>
        <div *ngIf="customSettings&&!customSettings.isHideEditorChoice"
            (click)="event.isChoice ? unChoice() : choice(); $event.stopPropagation()">
            <ig-card-action *ngIf="!event.isChoice" icon="favorite_border" [matTooltip]="addToEditorChoiceTextTip"
                matTooltipClass="card-tooltip" matTooltipPosition="right">
            </ig-card-action>
            <ig-card-action *ngIf="event.isChoice" icon="favorite" [matTooltip]="removeFromEditorChoiceTextTip"
                matTooltipClass="card-tooltip" matTooltipPosition="right">
            </ig-card-action>
        </div>
        <!--<div (click)="event.isCustom ? unCustom() : custom();$event.stopPropagation()">-->
        <!--<ig-card-action *ngIf="!event.isCustom" icon="star"-->
        <!--matTooltip="Add to custom button"-->
        <!--matTooltipPosition="right">-->
        <!--</ig-card-action>-->
        <!--<ig-card-action *ngIf="event.isCustom" icon="star_border"-->
        <!--matTooltip="Remove from custom button"-->
        <!--matTooltipPosition="right">-->
        <!--</ig-card-action>-->
        <!--</div>-->
        <div (click)="
        event.isToBeExport ? unToBeExport() : toBeExport();
        $event.stopPropagation()
      ">
            <ig-card-action *ngIf="!event.isToBeExport" icon="picture_as_pdf" matTooltip="Add to PDF export"
                matTooltipClass="card-tooltip" matTooltipPosition="right">
            </ig-card-action>
            <ig-card-action *ngIf="event.isToBeExport" icon="picture_as_pdf" matTooltip="Remove from PDF export"
                matTooltipClass="card-tooltip" matTooltipPosition="right">
            </ig-card-action>
        </div>
        <div (click)="showEditModal(); $event.stopPropagation()">
            <ig-card-action icon="edit" matTooltip="Edit event" matTooltipPosition="right"
                matTooltipClass="card-tooltip">
            </ig-card-action>
        </div>
        <div (click)="$event.stopPropagation();event.isLocked ? unlock($event) : lock($event); ">
            <ig-card-action [icon]="event.isLocked ? 'lock_open' : 'lock'"
                matTooltip="{{event.isLocked ? 'Unlock event' : 'Lock event, so that manually updated event data will not be reverted in the next deliveries'}}"
                matTooltipPosition="right" matTooltipClass="card-tooltip">
            </ig-card-action>
        </div>
        <!-- <div *ngIf="hubName !=='Savannah'" (click)="remove(); $event.stopPropagation()">
            <ig-card-action icon="delete_forever"
                matTooltip="Delete this single event permanently. If deleted, this event will not be re-added to the dashboard in the next content deliveries"
                matTooltipClass="card-tooltip" matTooltipPosition="right">
            </ig-card-action>
        </div> -->
        <div (click)="block(); $event.stopPropagation()">
            <ig-card-action icon="delete_forever"
                matTooltip="Move this event to your removed event list, events that are removed can be reverted as needed"
                matTooltipClass="card-tooltip" matTooltipPosition="right">
            </ig-card-action>
        </div>
        <!--		remove the delete event button for pulled events, as some clients are confused that if they delete an event, it will be added in the next pull-->
        <!--		<div *ngIf="event.isManuallyCreated" (click)="deletePermanently(); $event.stopPropagation()">-->
        <!--			<ig-card-action-->
        <!--				icon="delete_forever"-->
        <!--				matTooltip="Delete"-->
        <!--				matTooltipPosition="right"-->
        <!--			>-->
        <!--			</ig-card-action>-->
        <!--		</div>-->

        <ig-drop-down [class.position-initial]="
        parent.customBtns &&
        parent.customBtns.events &&
        parent.customBtns.events.length > 4
      " [class.lower-top]="
        parent.customBtns.events &&
        parent.customBtns.events.length > 4 &&
        parent.customBtns.events.length < 9
      " showDropDownItem="true" class="long-btn">
            <ig-drop-down-trigger [useDiv]="true" class="add-to-tour" icon="star" matTooltip="Add to custom button"
                matTooltipClass="card-tooltip" matTooltipPosition="right">
            </ig-drop-down-trigger>
            <div items>
                <ng-container *ngFor="let btn of parent.customBtns.events; let i = index">
                    <ig-drop-down-item *ngIf="btn.sourceType === 'selected'" (click)="addOrRemoveToCustomBtn(btn, i)"
                        matTooltip="{{ btn.btnText }}">
                        <mat-icon class="red" *ngIf="isInCustomBtn(btn)">remove</mat-icon>
                        <mat-icon *ngIf="!isInCustomBtn(btn)">add</mat-icon>
                        {{ btn.btnText }}
                    </ig-drop-down-item>
                </ng-container>
                <ig-drop-down-item *ngIf="!parent.customBtns.events || !parent.customBtns.events.length"
                    (click)="gotoTours()" matTooltip="Go to add a custom button" matTooltipClass="card-tooltip">(no
                    custom buttons available, create one)
                </ig-drop-down-item>

                <!-- <ig-drop-down-item *ngIf="hubName==='test4'||hubName==='Savannah'" (click)="aiCategory()"
                                   matTooltip="Classify events by AI assistant" matTooltipClass="card-tooltip">
                    <div>
                        <img src="https://iti-images.s3.amazonaws.com/imgs/ai-star.gif" alt="" width="20">
                        Try out AI Category Assistant
                    </div>
                </ig-drop-down-item> -->
            </div>
        </ig-drop-down>

        <ig-drop-down *ngIf="event.isApproved && isItineraryOn && !event.isOnlineEvent"
            [class.position-initial]="parent.tours && parent.tours.length > 4" [class.lower-top]="
        parent.tours && parent.tours.length > 4 && parent.tours.length < 9
      " showDropDownItem="true" class="long-btn">
            <ig-drop-down-trigger [useDiv]="true" class="add-to-tour" icon="directions_car"
                matTooltip="Add to itineraries" matTooltipClass="card-tooltip" matTooltipPosition="right">
            </ig-drop-down-trigger>
            <div items>
                <ig-drop-down-item *ngFor="let tour of parent.tours" (click)="addOrRemoveFromTour(tour)" matTooltip="{{ !isInTour(tour) ? 'Add to' : 'Remove from' }} {{
            tour.title
          }}">
                    <mat-icon class="red" *ngIf="isInTour(tour)">remove</mat-icon>
                    <mat-icon *ngIf="!isInTour(tour)">add</mat-icon>
                    {{ tour.title }}
                </ig-drop-down-item>

                <ig-drop-down-item *ngIf="!parent.tours || !parent.tours.length" (click)="gotoTours()"
                    matTooltip="Go to add an itinerary" matTooltipClass="card-tooltip">(no itineraries
                    available, create
                    one)
                </ig-drop-down-item>
            </div>
        </ig-drop-down>
    </div>

    <div #card detail>
        <div class="detail description word-break">
            <span (click)="updateEvent($event)"></span>{{ event.owner ? '@' + event.owner.name : '(no owner)' }}
        </div>
        <div class="title word-break" style="color: gray">
            {{ event.title || event.name }}
        </div>
        <div class="detail description long-description word-break">
            {{ descriptionText }}
        </div>
        <div class="detail" *ngIf="
        !event.eventTimes ||
        !event.eventTimes.length ||
        event.eventTimes.length === 1
      ">
            <span class="word-break time-unk" *ngIf="event.startTimeFormatted">
                {{ event.startTimeFormatted }}{{ event.endTimeFormatted ? " - " + event.endTimeFormatted : "" }}
                <mat-icon
                    *ngIf="event.startTimeFormatted.includes('UNK') || (event.endTimeFormatted && event.endTimeFormatted.includes('UNK'))"
                    matTooltip="You see UNK timezone because you didn't set the default timezone, please contact the administrator to set your default timezone"
                    class="not-change-tip">info</mat-icon>
            </span>
        </div>
        <div *ngIf="event.eventTimes && event.eventTimes.length > 1">
            <ng-container>
                <div class="times word-break time-unk" *ngFor="let timeRange of event.eventTimes.slice(0, 3)">
                    {{ timeRange.startTimeFormatted }} {{
                    timeRange.endTimeFormatted ? ' - ' + timeRange.endTimeFormatted
                    : ''
                    }}
                    <mat-icon
                        *ngIf="(timeRange.startTimeFormatted && timeRange.startTimeFormatted.includes('UNK')) || (timeRange.endTimeFormatted && timeRange.endTimeFormatted.includes('UNK'))"
                        matTooltip="You see UNK timezone because you didn't set the default timezone, please contact the administrator to set your default timezone"
                        class="not-change-tip">info
                    </mat-icon>
                </div>
            </ng-container>

            <div *ngIf="event.eventTimes.length > 3" class="times-more" (click)="showMoreTimes($event)">
                Show More
            </div>
            <br />
        </div>
        <div *ngIf="event.venue" class="detail word-break" style="padding-bottom: 0">
            Venue Name: {{ event.venue }}
        </div>
        <div class="detail word-break">
            Address: {{ event.address?.address || (event.isOnlineEvent ? 'Online Event' : '(no location)') }}
        </div>
        <a class="ticket"
            *ngIf="toggles.eventTicketUrl && !event.isHideTicketUrl && event.ticketUri && event.ticketUri !== 'undefined'"
            (click)="jumpToTicket($event)">Ticket: {{ event.ticketUri }}</a>
    </div>
</ig-card>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/calendar/event.card/hub.event.card.component.html